export const makeDonationModalStyle = {
	title: {
		textAlign: 'center',
		marginBottom: '40px',
	},

	search: {
		position: 'relative',
		// marginBottom: '66px',

		svg: {
			position: 'absolute',
			left: '10px',
			top: '30px',
		},

		'& .MuiFormControl-root .MuiInputBase-root input': {
			paddingLeft: '40px',

			'&::placeholder': {
				color: 'var(--neutral-300)',
			},
		},
		'& .MuiFormControl-root .MuiInputBase-root fieldset': {
			background: 'transparent',
		},
	},

	optionsList: {
		display: 'grid',
		gridTemplateColumns: 'repeat(3, 1fr)',
		gap: '12px',
		textAlign: 'center',
		marginBottom: '32px',

		'@media (max-width: 639.98px)': {
			gridTemplateColumns: 'repeat(2, 1fr)',
		},
	},

	option: {
		fontWeight: '400',
		padding: '10px 45px',
		borderRadius: '8px',
		boxShadow: 'var(--box-shadow--1)',
		border: '1px solid var(--neutral-100)',
		cursor: 'pointer',
	},

	selectedOption: {
		border: '1px solid var(--primary-500)',
		background: 'var(--primary-100)',
	},
};
